angular.module('app').config(costsAndPricesRouting);

function costsAndPricesRouting($routeProvider) {
  $routeProvider.when('/costs_and_prices', {
    pageTitle: 'COSTS_AND_PRICES',
    template: '<costs-and-prices-page></costs-and-prices-page>',
    accessPermission: [
      'index_tourcost_accountadmin',
      'index_transportationcost_accountadmin',
      'index_hotelcost_accountadmin',
      'index_packagecost_accountadmin',
    ],
    menu: 'inventory',
    authReq: true,
  });
}

costsAndPricesRouting.$inject = ['$routeProvider'];
